export const URL_ESTADO_GEO = 'https://grd.defesacivil.rs.gov.br/server/rest/services/Limite_rs/FeatureServer/0';
export const URL_MUNICIPIO_GEO = 'https://grd.defesacivil.rs.gov.br/server/rest/services/Municipio_rs/FeatureServer/0';
export const CENTROIDE_MAPA = [-30.30479, -53.286374];
export const ZOOM_INICIAL_MAPA = 7;
export const ZOOM_MAXIMO_MAPA = 16;
export const ZOOM_MINIMO_MAPA = 6;
export const PRECISION = 16;
export const LAGOA_DOS_PATOS = 4300002;
export const LAGOA_MIRIM = 4300001;
export const COLOR_MUNICIPIOS = "black";
export const COLOR_MUNICIPIOS_SELECIONADOS = "#dfdf22";

export const LEAFLET_DRAW_LOCALE = {
	draw: {
		toolbar: {
			actions: {
				title: "Cancelar desenho",
				text: "Cancelar"
			},
			finish: {
				title: "Finalizar desenho",
				text: "Finalizar"
			},
			undo: {
				title: "Desfaz o último ponto",
				text: "Desfazer"
			},
			buttons: {
				polyline: "Desenhar linhas",
				polygon: "Desenhar um polígono",
				rectangle: "Desenhar um retângulo",
				circle: "Desenhar um círculo",
				marker: "Desenhar um marcador",
				circlemarker: "Desenhar um marcador de círculo"
			}
		},
		handlers: {
			circle: {
				tooltip: {
					start: "Clique e arraste para desenhar um círculo."
				},
				radius: "Raio"
			},
			circlemarker: {
				tooltip: {
					start: "Clique no mapa para colocar um marcador de círculo."
				}
			},
			marker: {
				tooltip: {
					start: "Clique no mapa para adicionar um marcador."
				}
			},
			polygon: {
				tooltip: {
					start: "Clique para começar a desenhar uma geometria.",
					cont: "Clique para continuar desenhando uma geometria.",
					end: "Clique no primeiro ponto para fechar a geometria."
				}
			},
			polyline: {
				error:
					"<strong>Erro:</strong> as arestas da geometria não podem se cruzar.",
				tooltip: {
					start: "Clique para começar a desenhar uma linha.",
					cont: "Clique para continuar desenhando a linha.",
					end: "Duplo-clique para terminar o desenho da linha."
				}
			},
			rectangle: {
				tooltip: {
					start: "Clique e arraste para desenhar um retêngulo."
				}
			},
			simpleshape: {
				tooltip: {
					end: "Solte o mouse para terminar o desenho."
				}
			}
		}
	},
	edit: {
		toolbar: {
			actions: {
				save: {
					title: "Salvar alterações.",
					text: "Salvar"
				},
				cancel: {
					title: "Cancelar edições, descartar todas as alterações.",
					text: "Cancelar"
				},
				clearAll: {
					title: "Limpar todos os polígonos.",
					text: "Limpar tudo"
				}
			},
			buttons: {
				edit: "Editar polígono",
				editDisabled: "Não existem polígonos disponíveis para edição",
				remove: "Remover polígono",
				removeDisabled:
					"Não existem polígonos disponíveis para exclusão"
			}
		},
		handlers: {
			edit: {
				tooltip: {
					text: "Arraste o marcador para alterar sua localização.",
					subtext: 'Clique "Cancelar" para desfazer as mudanças.'
				}
			},
			remove: {
				tooltip: {
					text: "Clique em um desenho para removê-lo."
				}
			}
		}
	}
};
